/**
 * BulkResyncPanel — state orchestrator.
 *
 * Renders:
 *   BulkResyncHeader      → top bar controls
 *   BulkResyncIdleState   → pre-run empty state
 *   BulkResyncRunningState → in-progress spinner
 *   BulkResyncResults     → post-run result breakdown
 */
import React, { useState } from 'react';
import { BulkResyncHeader }       from './bulkresync/BulkResyncHeader';
import { BulkResyncIdleState }    from './bulkresync/BulkResyncIdleState';
import { BulkResyncRunningState } from './bulkresync/BulkResyncRunningState';
import { BulkResyncResults }      from './bulkresync/BulkResyncResults';
import { API, apiFetch } from '../lib/api';



export function BulkResyncPanel() {
  const [running,    setRunning]    = useState(false);
  const [result,     setResult]     = useState(null);
  const [onlyActive, setOnlyActive] = useState(false);

  const run = async () => {
    setRunning(true);
    setResult(null);
    try {
      const res  = await apiFetch(`${API}/integration/bulk-resync`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ onlyActive }),
      });
      setResult(await res.json());
    } catch (e) {
      setResult({ success: false, error: e.message });
    }
    setRunning(false);
  };

  return (
    <div className="card" style={{ borderTop: '3px solid #f59e0b' }} data-testid="bulk-resync-card">
      <BulkResyncHeader
        running={running}
        onlyActive={onlyActive}
        onToggleActive={setOnlyActive}
        onRun={run}
      />
      <div style={{ padding: 16 }}>
        {!result && !running && <BulkResyncIdleState />}
        {running              && <BulkResyncRunningState />}
        {result               && <BulkResyncResults result={result} />}
      </div>
      <style>{`.spin{animation:spin 1s linear infinite}@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

export default BulkResyncPanel;
